import { render, staticRenderFns } from "./CkditorCore.vue?vue&type=template&id=2a11cd5f"
import script from "./CkditorCore.vue?vue&type=script&lang=js"
export * from "./CkditorCore.vue?vue&type=script&lang=js"
import style0 from "./CkditorCore.vue?vue&type=style&index=0&id=2a11cd5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports